<div style="width: 100%">
    <button (click)="openHitPinAendern()" mat-flat-button color="accent" style="width: 100%">
        <mat-icon>password</mat-icon>&nbsp;HIT-PIN aktualisieren
    </button>
    <button *ngIf="showRemove" mat-flat-button color="warn" (click)="removeVVVO()" style="width: 100%; margin-top: 12px">
        <mat-icon>delete</mat-icon>&nbsp;VVVO entfernen
    </button>
</div>
